export enum AgendaRangeType {
  DAY = 'day',
  MONTH = 'month',
  WEEK = 'week',
  CUSTOM = 'custom'
}
